import {
    Message
} from "element-ui";
import {
    getAnalystRatingPeriod
} from "../../../api/analystRating";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
export const period = {
    data() { 
        return {
            params: {
                categoryName: "",
                period: ""
            },
            periodList: []
        }
    },
    methods: {
        getAnalystRatingPeriod(params) {
            let self=this;
            getAnalystRatingPeriod(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            self.periodList = result.data;
                            if(result.data.length == 0) {
                                self.invalidPeriod = true;
                            }
                            else {
                                self.invalidPeriod = false;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                });
        },
    }
}

